import React, {useEffect} from "react";
import {Grid, IconButton} from "@mui/material";
import {ArrowBack} from "@mui/icons-material";
import {RootGrid, HeaderTypography} from "./taxonomy";
import {PocConnectorProperties} from "../../../../settings/default_properties";
import SettingModifier from "../components/setting_modifier";
import {getAttributes as utilGetAttributes} from "../../../../../utils/utils";
import EnhancedErrorDialog from "../../../../../components/EnhancedErrorDialog";
import {pageContentGap} from "../../../../../theme";

export const CONNECTOR_PROPERTIES_DESCRIPTION = "These settings control which attributes are automatically posted to your external system (ex. Shopify) for all partners. If the following attributes have Approved changes in POC, you will receive those updates in your external system with the next scheduled job. When product data differs between your external system and POC, scheduled jobs will sync all product fields from POC, which may overwrite external changes.";

interface ErrorState {
    open: boolean;
    errorHeader: string;
    errorMessage: string;
}

interface ConnectorProps {
    setTitle: (title: string, flag?: boolean) => void;
    isRetailer: boolean;
    location: any;
    history: any;
}

const iconButtonSx = (theme: any) => ({
    backgroundColor: "white",
    border: "none",
    borderRadius: "6px",
    "& svg": { color: "rgba(0, 0, 0, 0.54)" }
});
export default function Connector(props: ConnectorProps) {
    const {setTitle} = props;
    const [error, setError] = React.useState<ErrorState>({open: false, errorHeader: "", errorMessage: ""});
    const [attributes, setAttributes] = React.useState<any[]>([]);
    useEffect(() => {
        if(setTitle) {
            setTitle('POC Connector Configs.', true);
        }
        const getAttributes = async () => {
            const attributes = await utilGetAttributes("", props.isRetailer);
            if (attributes.errorMessage) {
                setError(attributes);
            } else {
                setAttributes(attributes);
            }
        }
        getAttributes();
        // eslint-disable-next-line
    }, []);
    return (
        <RootGrid container
              style={{gap: pageContentGap, padding: "24px 14px 24px 14px", position: "relative"}}>
            <Grid container justifyContent={"space-between"} direction={"row"}>
                <Grid container justifyContent={"flex-start"} alignItems={"center"} style={{gap: pageContentGap, width: "100%"}}>
                    <IconButton
                        sx={iconButtonSx}
                        style={{height: "36px", width: "36px", position: 'relative', zIndex: 1}}
                        onClick={(e) => {
                            e.preventDefault();
                            if (props.location.key === undefined)
                                props.history.push("/productonboardingcenter/catalog");
                            else
                                props.history.goBack();
                        }}
                        size="large">
                        <ArrowBack style={{height: "18px", width: "18px"}}/>
                    </IconButton>
                    <HeaderTypography>
                        Connector Configurations
                    </HeaderTypography>
                </Grid>
            </Grid>
            <PocConnectorProperties
                isMulti={true}
                options={attributes}
                template={(templateProps: any) => {
                    return (
                        <SettingModifier
                            {...templateProps}
                            disablePartners={true}
                            propertiesDescription={CONNECTOR_PROPERTIES_DESCRIPTION}
                        />
                    );
                }}
            />
            <EnhancedErrorDialog open={error.open} onClose={() => setError({...error, open: false})}
                                 errorHeader={error.errorHeader} errorMessage={error.errorMessage}/>
        </RootGrid>
    );
}
